module.exports = __webpack_public_path__ + "static/media/3@4x.c2586982.png";